<p>You may continue your work, however some features and functions may not work as expected</p>

<app-checkbox [(ngModel)]="doNotShow" label="Do not show this message again"></app-checkbox>

<div class="button-row">
    <a class="btn btn-secondary" href="https://www.sircon.com/support/browserSupport.jsp" target="_blank" rel="noopener noreferrer">Learn More</a>
    <button type="button" class="btn btn-primary" (click)="closeDialog()">Ok</button>
</div>
